/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { makeAutoObservable } from 'mobx';
import { is } from 'bpmn-js/lib/util/ModelUtil';

import { createBpmnModdle } from 'utils/web-modeler-diagram-parser/moddle-util';

export function containsUserTasks(elements) {
  return elements.some((element) => is(element, 'bpmn:UserTask'));
}

export class DetectUserTasksStore {
  hasUserTasks = false;

  constructor() {
    makeAutoObservable(this);
  }

  setContainsUserTasks = (bool) => {
    this.hasUserTasks = bool;
  };

  detectContainsUserTasks = async (xml) => {
    try {
      if (xml) {
        const bpmnModdle = createBpmnModdle();

        const { elementsById } = await bpmnModdle.fromXML(xml);

        return containsUserTasks(Object.values(elementsById));
      }
    } catch (e) {
      console.info(e);
    }
    return false;
  };
}

export default new DetectUserTasksStore();
